import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cqes-icon',
  templateUrl: './cqes-icon.component.html',
  styleUrls: ['./cqes-icon.component.scss']
})
export class CqesIconComponent implements OnInit {

  @Input() icon: string;
  @Input() color: string;
  @Input() iconClass: string;

  isIE11 = false;

  constructor(private hostElementRef: ElementRef<HTMLElement>) {
    const ua = navigator.userAgent;
    const isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    this.isIE11 = isIe;
  }

  ngOnInit() {

  }

  get iconFillClass(): string {
    const classSource = this.getClassSource();

    if (classSource.indexOf('cqes-icon-outlined') > -1 || classSource.indexOf('outlined') > -1) {
      return 'cqes-icon-outlined';
    }

    if (classSource.indexOf('cqes-icon-filled') > -1 || classSource.indexOf('filled') > -1) {
      return 'cqes-icon-filled';
    }

    return 'cqes-icon-filled';
  }

  private getClassSource(): string {
    const inputClass = this.iconClass || '';
    const hostClass = this.hostElementRef?.nativeElement?.className || '';
    return (inputClass + ' ' + hostClass).toLowerCase();
  }

  get coloredIcon(): string {
    return this.icon + '-' + this.color;
  }

  get iconName(): string {
    let iconName = this.icon;
    if (this.color) {
      iconName += '-' + this.color;
    }
    if (this.iconClass) {
      iconName += '-' + this.iconClass;
    }

    return iconName;
  }

}

export const iconCodes = {
  done: 'done',
  archive: 'archive',
  pan_tool: 'pan_tool',
  delete: 'delete',
  fiber_new: 'fiber_new',
  screen_lock_landscape: 'screen_lock_landscape',
  fingerprint: 'fingerprint',
  touch_app: 'touch_app',
  smartphone: 'smartphone',
  swap_horiz: 'swap_horiz',
  alarm: 'alarm',
  blocked: 'blocked',
  developer_board: 'developer_board',
  account_circle: 'account_circle',
  exit_to_app: 'exit_to_app',
  contact_phone: 'contact_phone',
  email: 'email',
  shop: 'shop',
  info: 'info',
  store: 'store',
  history: 'history',
  bookmark_border: 'bookmark_border',
  payment: 'payment',
  dashboard: 'dashboard',
  menu: 'menu',
  hourglass_empty: 'hourglass_empty',
  search: 'search',
  archive_text_success: 'archive_text_success',
  delete_text_danger: 'delete_text_danger',
  error: 'error',
  folder: 'folder',
  cancel: 'cancel',
  save: 'save',
  add_circle_outline: 'add_circle_outline',
  close_danger: 'close_danger',
  forward_to_inbox: 'forward_to_inbox',
  mobile_screen_share: 'mobile_screen_share',
  web_identification_globus: 'web_identification_globus',
  face: 'face',
  visibility: 'visibility',
  done_all: 'done_all',
  mail_outline: 'mail_outline',
  usb: 'usb',
  restart_alt: 'restart_alt',
  data_table:'data_table',
  dataset: 'dataset',
  person: "person"
};
